import { render, staticRenderFns } from "./Rating5Star.vue?vue&type=template&id=7f53a6ea"
import script from "./Rating5Star.vue?vue&type=script&lang=js"
export * from "./Rating5Star.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f53a6ea')) {
      api.createRecord('7f53a6ea', component.options)
    } else {
      api.reload('7f53a6ea', component.options)
    }
    module.hot.accept("./Rating5Star.vue?vue&type=template&id=7f53a6ea", function () {
      api.rerender('7f53a6ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/Rating5Star.vue"
export default component.exports